var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[_c('keep-alive',{attrs:{"include":['StaffHistory','bind', 'MeetingBook', 'StaffMeetingHistory', 'Vouchers', 'MealBook', 'QrCode', 'qrCode', 'FaceAuth']}},[_c('router-view')],1),(_vm.isShowFooterBar)?_c('footer-bar'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }